import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { TableColumns } from '@/components/table/types';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { IAllEntitiesSummaryTableTotalRow } from '../../types';
import { InvestorDetailsSummaryTabHouseholdSummaryQuery } from '@/__generated__/graphql';

interface AllEntitiesSummaryTableSumFooterProps {
  tableColumns: TableColumns[];
  tableTotalRowData: InvestorDetailsSummaryTabHouseholdSummaryQuery['investorHouseholdSummary']['totals'] | null;
  showSpecificColumns: boolean;
}

const AllEntitiesSummaryTableSumFooter = ({ tableColumns, tableTotalRowData, showSpecificColumns }: AllEntitiesSummaryTableSumFooterProps) => {
  if (!tableTotalRowData) return <></>;

  const WIDTH = 100 / tableColumns.length;

  return (
    <TableSumWrap>
      <TableSumItem width={WIDTH}>Total</TableSumItem>
      {showSpecificColumns && (
        <TableSumItem width={WIDTH}>
          {tableTotalRowData.ignoreAllocationTargets ? <>--</> : <FormattingTooltip>{tableTotalRowData.entityValueTotal}</FormattingTooltip>}
        </TableSumItem>
      )}
      {showSpecificColumns && <TableSumItem width={WIDTH}></TableSumItem>}
      <TableSumItem width={WIDTH}>
        <FormattingTooltip>{tableTotalRowData.currentNAVTotal}</FormattingTooltip>
      </TableSumItem>
      <TableSumItem width={WIDTH}>
        <FormattingTooltip>{tableTotalRowData.unfundedCommitmentTotal}</FormattingTooltip>
      </TableSumItem>
      {showSpecificColumns && <TableSumItem width={WIDTH}></TableSumItem>}
      {showSpecificColumns && (
        <TableSumItem width={WIDTH}>
          {tableTotalRowData.ignoreAllocationTargets ? <>--</> : <FormattingTooltip>{tableTotalRowData.capacityTotal}</FormattingTooltip>}
        </TableSumItem>
      )}
    </TableSumWrap>
  );
};

const TableSumWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  width: 100%;
  min-height: 60px;
  background-color: ${themeVar('layer.2')};
  border-radius: 8px;
  padding: 0 24px;
`;

const TableSumItem = styled.div<{ width: number; cursor?: string }>`
  display: flex;
  justify-content: flex-start;
  width: ${({ width }) => `${width}%`};
  color: ${themeVar('font.base')};
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  cursor: ${({ cursor }) => cursor};
`;

export default AllEntitiesSummaryTableSumFooter;
